<div class="md-popover login-popover confirm-dialog">
  <section class="my-popover-content">
    <div class="input-group mb-3">
      <h4 class="confirm-message">{{confirmMessage}}</h4>
    </div>
    <div class="row confirm-actions">
      <button type="button" nz-button nzType="primary" (click)="modalClose(1)" class="confirm-btn">Confirm</button>
      <button type="button" nz-button nzType="default" (click)="modalClose(0)" class="confirm-btn">Cancel</button>
    </div>
  </section>
</div>
  
  
  